export { default } from './WebLinks';
